import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSignIn } from '@clerk/clerk-react';
import LoadingContainer from '@components/LoadingContainer';

export const Impersonate = () => {
	const [queryParams] = useSearchParams();
	const signInToken = queryParams.get('ticket');
	const { signIn, setActive } = useSignIn();
	const hasRun = useRef(false);

	if (!signInToken) throw Error('No token provided!');

	useEffect(() => {
		const clearSessionAndSignIn = async () => {
			if (!signIn) return;

			// Prevent double execution once signIn is ready
			if (hasRun.current) return;
			hasRun.current = true;

			try {
			
				const res = await signIn.create({
					strategy: 'ticket',
					ticket: signInToken
				});

				await setActive({ session: res.createdSessionId });

				// Use window.location instead of navigate() to avoid race condition
				// with Clerk's React context state updates
				window.location.href = '/home';
			} catch (error) {
				console.error('Impersonation failed:', error);
				window.location.href = '/login';
			}
		};

		clearSessionAndSignIn();
	}, [signIn, signInToken]);

	return <LoadingContainer />;
};
